const config = {
    apiKey: "AIzaSyDLQGy5sCK1S-etCcT_tfb5BgSy9VIUsCw",
    authDomain: "music-by-vote.firebaseapp.com",
    projectId: "music-by-vote",
    storageBucket: "music-by-vote.appspot.com",
    messagingSenderId: "342702557302",
    appId: "1:342702557302:web:2822c54db3643c6eff3757",
    measurementId: "G-BPMLGKSQ6M"
};
export default config;